import React from 'react';
import { services } from '../mock/mock';
import SectionHeading from './SectionHeading';

export default function Services() {
  return (
    <section id="services" className="relative py-24 px-5 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="What We Offer"
          title="Our Sacred Services"
          subtitle="Four pillars of divine guidance to align your life with cosmic harmony."
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7 mt-14">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.id}
                className="reveal group relative rounded-2xl p-7 text-center transition-all duration-500 hover:-translate-y-2"
                data-delay={i * 120}
                style={{
                  background: 'linear-gradient(180deg, #fffaf0, #f6e9cd)',
                  border: '1.5px solid #e2c887',
                  boxShadow: '0 10px 30px rgba(124,19,15,0.08)',
                }}
              >
                {/* corner ornaments */}
                <span className="absolute top-2 left-2 w-4 h-4 border-t-2 border-l-2 border-[#c9962e] rounded-tl" />
                <span className="absolute top-2 right-2 w-4 h-4 border-t-2 border-r-2 border-[#c9962e] rounded-tr" />
                <span className="absolute bottom-2 left-2 w-4 h-4 border-b-2 border-l-2 border-[#c9962e] rounded-bl" />
                <span className="absolute bottom-2 right-2 w-4 h-4 border-b-2 border-r-2 border-[#c9962e] rounded-br" />

                <div className="flex justify-center mb-5">
                  <div
                    className="w-20 h-20 rounded-full flex items-center justify-center transition-all duration-500 group-hover:scale-110"
                    style={{
                      background: 'radial-gradient(circle at 40% 30%, #a71c14, #5a0d0a)',
                      border: '3px solid #d9a63b',
                      boxShadow: '0 0 20px rgba(217,166,59,0.4)',
                    }}
                  >
                    {s.id === 'numerology' ? (
                      <div className="grid grid-cols-3 gap-[3px] text-[#f2d68a] font-heading text-[11px] leading-none">
                        {s.numbers.map((n) => (
                          <span key={n}>{n}</span>
                        ))}
                      </div>
                    ) : (
                      <Icon className="text-[#f2d68a]" size={34} strokeWidth={1.6} />
                    )}
                  </div>
                </div>

                <h3 className="font-heading font-semibold tracking-widest uppercase text-[#7c130f] text-lg">
                  {s.title}
                </h3>
                {s.price && (
                  <span
                    data-testid={`service-price-${s.id}`}
                    className="inline-block mt-2 px-4 py-1 rounded-full font-heading tracking-wider text-sm text-[#f2d68a]"
                    style={{
                      background: 'linear-gradient(90deg, #7c130f, #a71c14, #7c130f)',
                      border: '1px solid #d9a63b',
                    }}
                  >
                    {s.price}
                  </span>
                )}
                <div className="ornament-line w-16 mx-auto my-3" />
                <p className="font-body text-[#5a3a1c] text-lg leading-snug">{s.desc}</p>
                <p className="font-body text-[#8a6535] text-base leading-snug mt-3 opacity-0 max-h-0 group-hover:opacity-100 group-hover:max-h-40 transition-all duration-500 overflow-hidden">
                  {s.long}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
